import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { CircleAlert } from 'lucide-react'
import { apiLogout } from '@/api/user/logout'

export const Route = createFileRoute('/payment-inactive')({
  head: () => ({ meta: [{ title: 'Payment Required - Snowvault' }] }),
  component: PaymentInactive
})

function PaymentInactive() {
  const router = useRouter()

  async function handleLogout() {
    try {
      await apiLogout()
    } finally {
      router.update({
        context: {
          ...router.options.context,
          user: { isAuthenticated: false }
        }
      })
      await router.navigate({ to: '/login' })
    }
  }

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-md">
        <Card>
          <CardHeader className="items-center text-center">
            <CircleAlert className="mb-2 h-12 w-12 text-amber-500" />
            <CardTitle>Payment Required</CardTitle>
            <CardDescription>Your organisation&apos;s payment is not active.</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4 text-center">
            <p className="text-sm text-muted-foreground">
              Please contact your organisation administrator to update the payment information.
            </p>
            <div className="flex justify-center gap-2">
              <Button variant="outline" onClick={handleLogout}>
                Logout
              </Button>
              <Button onClick={() => window.location.reload()}>Refresh</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
